module.exports = __webpack_public_path__ + "static/media/alan.d38769a2.webp";